import { AuthContextType } from '../connectors/auth-context-connector/auth-context-connector';
import { HarmonyConnectorError } from '../connectors/connector-error';

export const convertTokenTypeForPartner = <T>(tokenType: AuthContextType, tokenTypeMap: Map<AuthContextType, T>): T => {
  if (tokenTypeMap.has(tokenType)) {
    return tokenTypeMap.get(tokenType) as T;
  }
  throw new TypeError(`Invalid Token Type - ${tokenType}`);
};

export const deriveTokenFromAuthContextForPartner = (
  authContextType: AuthContextType[],
  authContext: Record<string, any>,
  authContextData: Record<string, any>,
  tokenTypeMap: Map<AuthContextType, string>
): void => {
  if (authContextData) {
    authContextType.forEach(token => {
      const convertedTokenType = convertTokenTypeForPartner(token, tokenTypeMap);
      const tokenValue = authContextData?.[convertedTokenType]; // Ensure safe access
      if (tokenValue !== undefined) {
        authContext[token] = tokenValue;
      } else {
        throw new HarmonyConnectorError('AuthContextConnectorPartner', `Token ${token} is not available in authContextData`);
      }
    });
  } else {
    throw new HarmonyConnectorError('AuthContextConnectorPartner', 'Response from Auth Context API not available');
  }
};
